import clsx from 'clsx';
import React from 'react';

import * as styles from './Spinner.css';

interface Props {
  className?: string;
  svgClassName?: string;
}

export const Spinner = ({
  className = '',
  svgClassName = '',
  ...restProps
}: Props) => {
  const svgStyles = clsx({
    [styles.svg]: true,
    [svgClassName]: svgClassName,
  });

  const combinedProps = {
    ...restProps,
    className: clsx(styles.root, className),
  };

  return (
    <span {...combinedProps}>
      <svg
        className={svgStyles}
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 22 20"
      >
        <path d="M19.142 11.498c-.383-.105-.778.12-.883.502-.43 1.568-1.38 2.982-2.67 3.984-1.33 1.033-2.928 1.578-4.617 1.578-.854 0-1.693-.14-2.496-.418-.777-.27-1.505-.66-2.16-1.164-.96-.736-1.732-1.693-2.245-2.766l1.29.637c.356.177.787.032.963-.323.176-.357.03-.787-.325-.963l-2.902-1.436c-.353-.174-.78-.03-.96.318L.67 14.333c-.182.354-.04.787.312.967.104.053.216.078.326.078.262 0 .514-.143.64-.393l.715-1.398c.22.5.487.982.8 1.44.544.798 1.212 1.503 1.983 2.093.778.598 1.64 1.062 2.563 1.38.955.332 1.953.5 2.967.5s2.008-.168 2.957-.498c.916-.32 1.77-.785 2.542-1.383.762-.59 1.42-1.296 1.96-2.097.547-.812.955-1.7 1.213-2.643.104-.382-.12-.778-.503-.882zM21.013 6.117c-.355-.176-.787-.03-.963.325l-.534 1.08c-.466-1.65-1.385-3.14-2.66-4.282-.79-.708-1.69-1.26-2.672-1.643-1.02-.396-2.1-.597-3.21-.597-2.187 0-4.293.794-5.932 2.236-1.622 1.427-2.68 3.387-2.975 5.52-.055.393.22.755.613.81.033.005.066.007.1.007.353 0 .66-.26.71-.62.25-1.79 1.138-3.438 2.5-4.638 1.377-1.21 3.147-1.878 4.982-1.878.933 0 1.838.168 2.69.5.82.32 1.572.782 2.234 1.374 1.138 1.02 1.94 2.373 2.305 3.868l-1.48-.66c-.362-.16-.787.003-.948.366-.16.362.002.787.364.948l2.923 1.3c.094.042.192.06.29.06.266 0 .52-.145.645-.4l1.343-2.713c.176-.357.03-.788-.325-.963z" />
      </svg>
    </span>
  );
};
